import api from "../../services/api";

export default {
  addBasicInfo: ({ commit }, payload) => commit("ADD_BASIC_INFO", payload),
  addPhotoFile: ({ commit }, payload) => commit("ADD_PHOTO_FILE", payload),
  addUpdatePhotoUrl: ({ commit }, payload) =>
    commit("ADD_UPDATE_PHOTO_URL", payload),
  addCurriculumUrl: ({ commit }, payload) =>
    commit("ADD_CURRICULUM_URL", payload),

  parseBasicInfo: ({ commit }, payload) => {
    const { user, talent } = payload.data;
    const commitPayload = {
      cpf: talent[0].ssn,
      name: user.name,
      born: talent[0].birthday,
      email: user.email,
      gender: talent[0].gender === 0 ? "Masculino" : "Feminino",
      photoURL: talent[0].photo_url,
      telephone: talent[0].telephone,
      maritalStatus: talent[0].marital_status,
      curriculumURL: talent[0].curriculumn_url
    };

    commit("PARSE_BASIC_INFO", commitPayload);
    return payload;
  },

  store: ({ commit }, payload) => commit("store", payload),

  clearBasicInfoState: ({ commit }) => commit("CLEAR_BASIC_INFO_STATE"),

  updateAvatar: async ({ commit }, { file, label }) => {
    const formData = new FormData();

    if(file !== null || file !== undefined){
      formData.append("photo_filename", file);
      const response = await api.post(
        `api/v1/talent/${label}/user/talent/upload/photo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      commit("ADD_UPDATE_PHOTO_URL", response.data.photo_filename);
    }
  },

  updateName: async ({ commit }, { name }) => {
    await api.post("api/v2/talents/profile/user", { name });
    commit("updateName", name);
  },

  updateEmail: async ({ commit }, { email }) => {
    await api.post("api/v2/talents/profile/user", { email });
    commit("updateEmail", email);
  }
};
